import { render, staticRenderFns } from "./WordCloudChartDisplay.html?vue&type=template&id=f4af224e&scoped=true&"
import script from "./WordCloudChartDisplay.js?vue&type=script&lang=js&"
export * from "./WordCloudChartDisplay.js?vue&type=script&lang=js&"
import style0 from "./WordCloudChartDisplay.scss?vue&type=style&index=0&id=f4af224e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4af224e",
  null
  
)

export default component.exports